<template>
  <v-card
    class="login-dialog--login__content"
    flat
    :class="layout == 'portal' ? 'fixit-background-gradient' : ''"
    :style="!$vuetify.breakpoint.smAndDown ? 'height: 600px' : ''"
  >
    <v-app-bar flat color="rgba(0, 0, 0, 0)" v-if="!(origin == 'fixitOAuth' || origin.includes('Homepages'))">
      <v-btn color="#472449" text @click="changeView('select_screen')">
        <v-icon size="30">fxt-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="#472449" icon @click="close">
        <v-icon size="30">fxt-close</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="login-dialog--login__content-container">
      <the-code
        title="Er dette deg?"
        :description="'Bekreft ved å taste engangskoden som du har mottatt fra oss på '"
        :error="error"
        :showResendText="showResendText"
        @changed="resetError()"
        :email="username.includes('@') ? username : email"
        :layout="layout"
        @setValue="setCode"
        @verify="VerifyAndLogin(false)"
      ></the-code>
      <div
        class="login-dialog--login__content-container--options"
        :class="
          !$vuetify.breakpoint.smAndDown
            ? 'login-dialog--login__content-container--options_limited'
            : ''
        "
      >
        <v-btn
          block
          color="#472449"
          dark
          text
          rounded
          :class="!$vuetify.breakpoint.smAndDown ? 'my-3' : ''"
          @click="resendCode()"
        >
          Send kode på nytt
        </v-btn>
        <v-btn
          block
          color="#472449"
          dark
          outlined
          rounded
          :class="!$vuetify.breakpoint.smAndDown ? 'my-3' : ''"
          @click="VerifyAndLogin(true)"
        >
          Bruk e-posten som er registrert i Vipps
        </v-btn>
      </div>
    </div>
  </v-card>
</template>
<script>
import { TheCode } from "../../Common/CommonSteps";
import AppSvc from "../../../services/app-svc";

let service = null;

export default {
  name: "the-selection",
  components: {
    TheCode,
  },
  props: {
    isTpn: {
      type: Boolean,
      required: true,
    },
    tpnChainId: {
      type: Number,
      required: true,
    },
    tpnSiteId: {
      type: Number,
      required: true,
    },
    useAxios: Boolean,
    apiUrl: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    clientIdentity: {
      type: String,
      required: true,
    },
    username: {
      type: String,
      required: false,
    },
    vippsEmail: {
      type: String,
      required: false,
      default: "",
    },
    layout: {
      type: String,
      required: false,
      default: "chain",
    },
  },
  data() {
    return {
      currentForm: "verify-email",
      previousForm: "",
      code: "",
      showResendText: false,
      error: "",
    };
  },
  computed: {
    origin(){
      return localStorage.getItem('origin') ?? ''
    }
  },
  methods: {
    setCode(value) {
      this.code = value;
    },
    resetError() {
      this.error = "";
    },
    changeView(state) {
      this.$emit("changeView", state);
    },
    close() {
      this.$emit("close");
    },
    VerifyAndLogin(reuseEmail) {
      var body = {
        username: this.username || this.email,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        clientIdentity: this.clientIdentity,
        code: this.code,
        email: this.email,
        vippsEmail: this.vippsEmail,
      };
      service.VerifyAndLogin(this.apiUrl, body, reuseEmail).then((response) => {
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.email = result.fixitNoUser?.email
            ? result.fixitNoUser?.email
            : this.email;
          this.clientIdentity = result.clientIdentity;
          this.previousForm = this.currentForm;
          this.currentForm = result.nextStep;
          if (result.nextStep === "welcome-screen") {
            this.$emit("setUser", result.fixitNoUser);
          }
        } else {
          this.showResendText = false;
          this.error = response.data.responseMessage;
        }
      });
    },
    resendCode() {
      var body = {
        username: this.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step: this.currentForm,
        email: this.email,
        resendCode: 'true'
      };

      service.VerifyLoginStep(this.apiUrl, body).then((response) => {
        this.showResendText = true;
        if (response.data.responseCode === 200) {
          var result = response.data;
          this.clientIdentity = result.clientIdentity;
        }
      });
    },
  },
  async created() {
    service = await AppSvc(this.useAxios ? this.$axios : null);
  },
};
</script>
<style lang="scss">
@import "../../../assets/styles/login-method.scss";
</style>
